import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, type OnInit } from '@angular/core';

import type { Widgets } from '@common/enums';
import { ETariffAbbr } from '@common/enums';
import { type Observable, take, withLatestFrom } from 'rxjs';

import { UserFacade } from '@web/store/user/user.facade';
import { PagesFacade } from '@web/store/website/pages/pages.facade';

import { PaidAccessNotificationComponent } from './paid-access-notification.component';

@Component({
    selector: 'web-paid-access-notification-container',
    template: `<web-paid-access-notification
        *ngIf="!hasAccess"
        [widgetName]="widgetName"
        [nextTariff]="nextTariff"
        [isEduSite]="isEduSite"
    ></web-paid-access-notification> `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, PaidAccessNotificationComponent],
})
export class PaidAccessNotificationContainerComponent implements OnInit {
    @Input() widgetName: Widgets;

    private readonly userFacade: UserFacade = inject(UserFacade);
    private readonly pagesFacade: PagesFacade = inject(PagesFacade);

    public readonly isEduSite$: Observable<boolean> = this.pagesFacade.isEduSite$;

    public readonly ETariffAbbr = ETariffAbbr;
    public nextTariff: ETariffAbbr;
    public hasAccess: boolean;
    public isEduSite: boolean;

    public ngOnInit(): void {
        this.userFacade
            .hasAccessToElement(this.widgetName)
            .pipe(withLatestFrom(this.isEduSite$), take(1))
            .subscribe(([{ hasAccess, nextTariff }, isEduSite]) => {
                this.hasAccess = hasAccess;
                this.nextTariff = nextTariff;
                this.isEduSite = isEduSite;
            });
    }
}
